import type { StateCreator } from 'zustand';

import type { GlobalStore, OnboardingSlice } from '../schema';

export const createOnboardingSlice: StateCreator<
  GlobalStore,
  [['zustand/devtools', never]],
  [],
  OnboardingSlice
> = (set) => ({
  activeOnboardingKey: null,
  setActiveOnboardingKey: (key) => set({ activeOnboardingKey: key }, false, 'onboarding/setKey'),
});
